import {Box, Skeleton} from '@mui/material';

const SplitsConfirmationSkeleton = () => (
  <>
    <Box className="splits-confirmation-row">
      <Skeleton
        variant="text"
        width={120}
        animation="wave"
      />
      <Skeleton
        variant="text"
        width={60}
        animation="wave"
      />
    </Box>

    <Box className="splits-confirmation-row">
      <Skeleton
        variant="text"
        width={100}
        animation="wave"
      />
      <Skeleton
        variant="text"
        width={140}
        animation="wave"
      />
    </Box>

    <div className="splits-confirmation-divider" />

    {[1, 2, 3].map(i => (
      <Box
        key={i}
        className="splits-confirmation-row splits-confirmation-row-owes">
        <Skeleton
          variant="circular"
          width={28}
          height={28}
          animation="wave"
        />
        <Skeleton
          variant="text"
          width={80}
          animation="wave"
        />
        <Skeleton
          variant="text"
          width={50}
          animation="wave"
        />
      </Box>
    ))}
  </>
);

export default SplitsConfirmationSkeleton;
